const ServiceSteps = ({
  step,
  title,
  description,
}: {
  step: string;
  title: string;
  description: string;
}) => {
  return (
    <div className="flex flex-col gap-4">
      <span className="text-ring text-6xl">{step}</span>
      <span className="text-primary text-2xl capitalize">{title}</span>
      <span className="text-primary">{description}</span>
    </div>
  );
};

export default ServiceSteps;
